import { render, staticRenderFns } from "./annualPayable-detail.vue?vue&type=template&id=36e85811"
import script from "./annualPayable-detail.vue?vue&type=script&lang=js"
export * from "./annualPayable-detail.vue?vue&type=script&lang=js"
import style0 from "./annualPayable-detail.vue?vue&type=style&index=0&id=36e85811&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports